  /**
 * RRHH Management Page
 */
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import mt from 'moment-timezone';
import 'moment/locale/es';
moment.locale('es');
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Fab } from '@material-ui/core';
import {NumericFormat } from 'react-number-format';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


import {
	Form,
	FormGroup,
	Label,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormText,
	Col,
	FormFeedback,
        Button as Btn,
	Input as In,


} from 'reactstrap';

// rct card box
import { RctCard, RctCardContent } from 'Components/RctCard';

//Actions
import { deleteClient } from "Actions";

function TabContainer({ children, dir }) {
   return (
      <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
         {children}
      </Typography>
   );
}

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { NotificationManager } from 'react-notifications';
import Avatar from '@material-ui/core/Avatar';
import { format, parseISO  } from 'date-fns';
// api
import api from 'Api';

// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
// rct section loader
import RctSectionLoader from 'Components/RctSectionLoader/RctSectionLoader';


class Calendario extends Component {
    constructor(props) {
        super(props);

        this.state = {
          events: [],
          eventId: null,
          loading: true,
          showModal: false,
          selectedStart: null,
          selectedEnd: null,
          title: '',
          description: '',
          notifica:false,
          notificar_dias_antes:0,
          currentView: 'month',
          view: 'month', // Vista inicial
          currentDate: new Date()
        };

        this.Init = this.Init.bind(this);
        this.handleSlotSelect = this.handleSlotSelect.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }
    
    handleNavigate = (date) => {
        this.setState({
          currentDate: date,
        });
      };

      handleViewChange = (view) => { 
        this.setState({
          view: view,
        });
      };

    
    componentWillMount(){
        const { location, history} = this.props;
        axios.get('/checkloggin', {}).then((response) => {
          if(!response.data){
              if (localStorage.getItem("user_id") !== null) {
                    localStorage.removeItem('user_id');
                    localStorage.removeItem('name');
                    localStorage.removeItem('email');
                    localStorage.removeItem('rol');
                    history.push('/signin');
                    NotificationManager.error('¡Se ha perdido la sesión!');
                }
          } else {
              let rol = response.data.rol;
              if(rol != 'administrador' ){
                    history.push('/session/404');
              }
              this.Init();
          }
        }, (error) => {
            this.setState({ loading: false });
            console.log(error);

        });
    }
    
    handleDeleteEvent = () => {
        const { selectedEvent, events, eventId  } = this.state;
        if (!eventId) return;

         this.setState({ loading: true });
            axios.delete('/agenda/eventos/'+eventId)
             .then(response => {

               const eventos = response.data.eventos.map(evento => ({
                       ...evento,
                       start: mt.utc(evento.inicio).tz('America/Santiago').toDate(),
                       end: mt.utc(evento.fin).tz('America/Santiago').toDate()
                     }));
               this.setState({ showModal: false, loading: false, events:eventos, title: '',description: ''  });
               NotificationManager.success(response.data.message);
             })
             .catch(error => {

                 this.setState({ loading: false });

                  if (error.response) {
                      if(Array.isArray(error.response.data.message)){
                          for(let i=0;i<error.response.data.message.length;i++){
                              NotificationManager.error(error.response.data.message[i]);
                          }
                      } else {
                          NotificationManager.error(error.response.data.message);
                      }
                     } else if (error.request) {
                       NotificationManager.error(error.request);
                     } else {
                       NotificationManager.error(error.message);
                     }
            });

      };
    
     handleSlotSelect = (slotInfo) => {
         
         let startDate, endDateRaw, fixedStart, endDate;
         
        if (this.state.currentView === 'month') {
            startDate = new Date(slotInfo.start);
            endDateRaw = new Date(slotInfo.end);

            // Set start hour to 08:00
            fixedStart = new Date(startDate.setHours(8, 0, 0, 0));

            // Adjust end: restar un día y fijar hora 08:00
            endDate = new Date(endDateRaw);
            endDate.setDate(endDate.getDate() - 1);
            endDate.setHours(8, 0, 0, 0); // 👈 Aquí va 08:00 am
        } else if (this.state.currentView === 'day' || this.state.currentView === 'week') {
            
            fixedStart = slotInfo.start;
            endDate = slotInfo.end;
        } else {
            return;
        }

         
        this.setState({
          showModal: true,
          selectedStart: fixedStart,
          selectedEnd: endDate,
          title: '', // Título vacío
          description: '', // Descripción vacía
          notifica:false,
          notificar_dias_antes: 0,
          editingEvent: false, // Modo creación
        });
      }

      toggleModal() {
        this.setState(prev => ({ showModal: !prev.showModal }));
      }
      
      formatTimeInput(date) {
        if (!date) return '';
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      }

      updateStartTime = (value) => {
        const [hours, minutes] = value.split(':').map(Number);
        const newDate = new Date(this.state.selectedStart);
        newDate.setHours(hours, minutes);
        this.setState({ selectedStart: newDate });
      }

      updateEndTime = (value) => {
        const [hours, minutes] = value.split(':').map(Number);
        const newDate = new Date(this.state.selectedEnd);
        newDate.setHours(hours, minutes);
        this.setState({ selectedEnd: newDate });
      }

    Init(){
        axios.get(`/agenda/eventos`)
        .then(
            (response) => {
               
                const eventos = response.data.events.map(evento => ({
                        ...evento,
                        start: mt.utc(evento.inicio).tz('America/Santiago').toDate(),
                        end: mt.utc(evento.fin).tz('America/Santiago').toDate()
                      }));
                 this.setState({ loading: false, events:eventos});
            })
        .catch(error => {
           NotificationManager.error(error.message);
           this.setState({ loading: false });
     })    
        
    }
    
    handleSelectEvent = event => {
        this.setState({
          selectedEvent: event, // Guardamos el evento que se está editando
          selectedStart: new Date(event.start), // Hora de inicio
          selectedEnd: new Date(event.end), // Hora de fin
          title: event.title, // Cargamos el título
          description: event.description || '', // Descripción si existe
          eventId: event.id, // aquí se guarda el ID
          showModal: true, // Abrimos la modal
          editingEvent: true, // Modo edición
          notifica: event.notifica !== 0, // aquí se guarda el ID
          notificar_dias_antes: event.notificar_dias_antes, // aquí se guarda el ID
        });
};
    
  handleSaveEvent = () => {
  const {eventId, selectedStart, selectedEnd, title, description, editingEvent, selectedEvent, notificar_dias_antes , notifica } = this.state;

  const event = {
    id: eventId, // importante si es edición
    title,
    start: selectedStart,
    end: selectedEnd,
    description,  // Agregamos la descripción
    notifica,
    notificar_dias_antes
  };

  if (editingEvent && eventId) { //put
    // Si es un evento editado, actualizamos el evento
    const updatedEvents = this.state.events.map(e =>
      e === selectedEvent ? event : e
    );
    
    this.setState({ loading: true });
     axios.put('/agenda/eventos/'+eventId, event)
      .then(response => {
       
        const eventos = response.data.eventos.map(evento => ({
                ...evento,
                start: mt.utc(evento.inicio).tz('America/Santiago').toDate(),
                end: mt.utc(evento.fin).tz('America/Santiago').toDate()
              }));
        this.setState({ showModal: false, loading: false, events:eventos, title: '',description: ''  });
        NotificationManager.success(response.data.message);
      })
      .catch(error => {
        
          this.setState({ loading: false });

           if (error.response) {
               if(Array.isArray(error.response.data.message)){
                   for(let i=0;i<error.response.data.message.length;i++){
                       NotificationManager.error(error.response.data.message[i]);
                   }
               } else {
                   NotificationManager.error(error.response.data.message);
               }
              } else if (error.request) {
                NotificationManager.error(error.request);
              } else {
                NotificationManager.error(error.message);
              }
     });

  } else { //post
     
     this.setState({ loading: true });
     axios.post('/agenda/eventos', event)
      .then(response => {
       
       
        const eventos = response.data.eventos.map(evento => ({
                ...evento,
                start: mt.utc(evento.inicio).tz('America/Santiago').toDate(),
                end: mt.utc(evento.fin).tz('America/Santiago').toDate()
              }));
        this.setState({ showModal: false, loading: false, events:eventos, title: '',description: ''});
        NotificationManager.success(response.data.message);
      })
      .catch(error => {
        
          this.setState({ loading: false });

           if (error.response) {
               if(Array.isArray(error.response.data.message)){
                   for(let i=0;i<error.response.data.message.length;i++){
                       NotificationManager.error(error.response.data.message[i]);
                   }
               } else {
                   NotificationManager.error(error.response.data.message);
               }
              } else if (error.request) {
                NotificationManager.error(error.request);
              } else {
                NotificationManager.error(error.message);
              }
     });

  }
};

    render(){
        
        const { theme, clientsData } = this.props;
        const { loading,  events, showModal, selectedStart, selectedEnd, editingEvent, title, description, currentDate, view, notifica, notificar_dias_antes } = this.state;
        const Localizer = momentLocalizer(moment);
        const CustomAgendaEvent = ({ event }) => (
        <span>
          <strong>{event.title}</strong><br />
          {event.description && <em>{event.description}</em>}
        </span>
      );
        return ( 
             <div className="data-table-wrapper">
                    <Helmet>
                            <title>{process.env.MIX_APP_NAME} | Calendario</title>
                            <meta name="description" content="Calendario" />
                    </Helmet>
                    <PageTitleBar
                            title={"Calendario"}
                            match={this.props.match}
                    />
                     <RctCollapsibleCard  fullBlock>
                    <Calendar
				localizer={Localizer}
				selectable
				events={events}
                                components={{
                                    agenda: {
                                      event: CustomAgendaEvent
                                    }
                                  }}
                                date={currentDate} 
                                onNavigate={(date) => this.setState({ currentDate: date })}
                                onView={view => this.setState({ currentView: view })}  
				defaultView="month"
				scrollToTime={new Date(2020, 1, 1, 6)}
				defaultDate={new Date()}
				onSelectEvent={this.handleSelectEvent}
                                onSelectSlot={this.handleSlotSelect}
                                formats={{
                                    timeGutterFormat: 'HH:mm',     // eje lateral horario
                                    eventTimeRangeFormat: ({ start, end }, culture, local) =>
                                    local.format(start, 'HH:mm', culture) + ' – ' + local.format(end, 'HH:mm', culture),
                                    agendaTimeFormat: 'HH:mm',     // para vista agenda
                                    agendaHeaderFormat: ({ start, end }, culture, local) =>
                                        start.getTime() === end.getTime()
                                          ? local.format(start, 'D MMM YYYY', culture)
                                          : `${local.format(start, 'D MMM YYYY', culture)} – ${local.format(end, 'D MMM YYYY', culture)}`
                                    }}
                                messages={{
                                    date: 'Fecha',
                                    time: 'Hora',
                                    event: 'Evento',
                                    allDay: 'Todo el día',
                                    week: 'Semana',
                                    work_week: 'Semana laboral',
                                    day: 'Día',
                                    month: 'Mes',
                                    previous: 'Anterior',
                                    next: 'Siguiente',
                                    yesterday: 'Ayer',
                                    tomorrow: 'Mañana',
                                    today: 'Hoy',
                                    agenda: 'Agenda',
                                    noEventsInRange: 'No hay eventos en este rango.',
                                    showMore: total => `+${total} más`
                                  }}
			/>
                        { loading &&
                            <RctSectionLoader />
                        }       
                        </RctCollapsibleCard>
                        <Modal backdrop="static" isOpen={showModal} toggle={this.toggleModal}>
                            <ModalHeader toggle={this.toggleModal}>
                              {editingEvent ? 'Editar Evento' : 'Nuevo Evento'}
                            </ModalHeader>
                            <ModalBody>
                              <div className="form-group">
                                <label>Título</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={title}
                                  onChange={e => this.setState({ title: e.target.value })}
                                />
                              </div>
                              <div className="form-group">
                                <label>Descripción</label>
                                <textarea
                                  className="form-control"
                                  value={description}
                                  onChange={e => this.setState({ description: e.target.value })}
                                />
                              </div>
                              <div className="form-group">
                                <label>Hora de inicio – {moment(selectedStart).format('dddd D [de] MMMM')}</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  value={moment(selectedStart).format('HH:mm')}
                                  onChange={e => {
                                    const [hours, minutes] = e.target.value.split(':');
                                    const nuevaFecha = new Date(selectedStart);
                                    nuevaFecha.setHours(Number(hours), Number(minutes));
                                    this.setState({ selectedStart: nuevaFecha });
                                  }}
                                />
                              </div>
                              <div className="form-group">
                                <label>Hora de fin – {moment(selectedEnd).format('dddd D [de] MMMM')}</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  value={moment(selectedEnd).format('HH:mm')}
                                  onChange={e => {
                                    const [hours, minutes] = e.target.value.split(':');
                                    const nuevaFecha = new Date(selectedEnd);
                                    nuevaFecha.setHours(Number(hours), Number(minutes));
                                    this.setState({ selectedEnd: nuevaFecha });
                                  }}
                                />
                              </div>
                              <div className="form-group">
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={this.state.notifica}
                                    onChange={e => this.setState({ notifica: e.target.checked })}
                                    className="mr-2"
                                  />
                                  ¿Desea recibir una alerta?
                                </label>
                              </div>

                              {this.state.notifica && (
                                <div className="form-group">
                                  <label>¿Cuándo notificar?</label>
                                  <select
                                    className="form-control"
                                    value={this.state.notificar_dias_antes}
                                    onChange={e => this.setState({ notificar_dias_antes: e.target.value })}
                                  >
                                    <option value="0">Seleccione periodo de notificación</option>
                                    <option value="-1">Mismo día (1 hora antes)</option>
                                    <option value="1">1 día antes</option>
                                    <option value="2">2 días antes</option>
                                    <option value="5">5 días antes</option>
                                    <option value="7">1 semana antes</option>
                                    <option value="14">2 semanas antes</option>
                                    <option value="30">1 mes antes</option>
                                  </select>
                                </div>
                                  )}                          
                            </ModalBody>
                            <ModalFooter>
                            {editingEvent && (
                                <Button
                                  id="deleteEventBtn"
                                  variant="contained"
                                  className="text-white btn-danger"
                                  onClick={this.handleDeleteEvent}
                                >
                                  Eliminar
                                </Button>
                              )}
                              <Button
                                variant="contained"
                                className="text-white btn-primary"
                                onClick={this.handleSaveEvent}
                              >
                                {editingEvent ? 'Actualizar Evento' : 'Guardar Evento'}
                              </Button>
                              <Button
                                variant="contained"
                                className="text-white btn-secondary"
                                onClick={this.toggleModal}
                              >
                                Cancelar
                              </Button>
                            </ModalFooter>
                          </Modal>
            </div>
        );
    }
}

export default (withStyles(null, { withTheme: true })(Calendario));